(function() {
    'use strict';

    var trackingUtils = require('../modules/utils/tracking.utils');
    var tagManagement = require('../modules/utils/tag_management.utils');
    var paymentGeneric = require('../modules/handlers/paymentpage');
    const createWidgetLoader = require('components-framework/widget/create_widget_loader');
    var fieldUtils = require('../modules/utils/field.utils');
    var priceManagerCollection = require('../modules/collections/pricemanager.collection').getInstance();
    var changeTab = require('../modules/utils/tab_title.utils');
    const myPsd2PopupManagerFactory = require('components/psd2/psd2_popup_manager/js/main');
    const paymentButtonFactory = require('components/payment/payment_button/js/main');
    var sessionManagement = require('../modules/utils/session.utils');
    const ConfirmationHandler = require('../modules/confirm/response_handler');
    const handler3DS = require('../modules/3ds/index').default;

    Odigeo.Router.handlers.pbpayment = function() {
        var widgets = Odigeo.autoloadWidgets({
            getUsersManager: ['users-manager', 'usersmanager'],
            getBinDetection: ['payment-bin-detection-manager', 'bindetectionmanager'],
            dpWaitingPage: ['dpwaiting-page', 'dp_waiting_page'],
            accommodationDetails: ['accommodation-details', 'accommodation_details'],
            getPaymentManager: ['payment-manager', 'paymentmanager'],
            getPaymentErrorManager: ['payment-error-manager', 'paymenterrormanager'],
            getInvoiceManager: ['invoice-manager', 'invoice_manager'],
            getSpecialrequestManager: ['specialrequest', 'special_request_manager'],
            nagManager: ['nagmanager', 'nagmanager'],
            binDetectionManager: ['payment-bin-detection-manager', 'bin_detection_manager'],
        });
        var isSidebarSummary = $('.side_summary_payment').data('type') === 'sidebarsummary';
        var asyncWidgets = Odigeo.autoloadWidgetsAsync({
            getPriceManagerEnhanced: ['price-breakdown-payments', 'pricemanager_enhanced'],
            getSidebar: isSidebarSummary ? ['sidebar-summary-payment', 'sidebar_summary'] : ['trip-summary-price-payment', 'trip_summary_price'],
            getLoginHeader: ['login-header', 'login'],
        });
        const widgetLoader = createWidgetLoader({
            psd2PopupManager: ['psd2-popup-manager', myPsd2PopupManagerFactory],
            paymentButton: ['payment-button', paymentButtonFactory],
        });
        var page = 'pbpayment';
        var $payment = $('#pbpayment');
        const $priceBreakDownContainer = $payment.find('.price_breakdown_payments_container');
        var invoiceData = {};
        var lastRoute = JSON.parse(Odigeo.Session.get('lastRouteChange'));

        var appName = '_ACCOMMODATIONPB_';
        const paymentHandlerResponse = new ConfirmationHandler($payment, widgetLoader, appName);
        var $logo = $('#logo');
        var _submitBinDetectionRequest;
        var _submitPriceManagerRequest;
        var $ccCardType = $('input[name="cardType"]');
        var $ccNotDetected = $('.cc_not_detected');
        var $persuasionMessagePopup = $payment.find('.persuasion_message_popup');
        var $persuasiveTitleName = $payment.find('#persuasive_title_name');
        var $persuasiveTitleWithName = $payment.find('.almost_done_with_name');
        var $persuasiveTitleWithoutName = $payment.find('.almost_done_without_name');
        var togglePaymentBtn;
        var $footer = $('#footer');
        var $page = $('#page');
        var $window = $(window);
        var bodyHeight = 0;
        var footerTop = 0;
        var paymentMainHeight = 0;

        _submitBinDetectionRequest = function(action, data) {
            Odigeo.requireWidget('payment-bin-detection-manager', 'bin_detection_manager', function(bindetectionmanager) {
                bindetectionmanager.execute(action, data);
            });
        };

        _submitPriceManagerRequest = function(action, ccName, ccResolved) {
            asyncWidgets.getPriceManagerEnhanced().execute(action, {
                'ccName': ccName,
                'resolved': ccResolved,
            });

            if (!Odigeo._.isUndefined(ccName)) {
                asyncWidgets.getSidebar().execute('setCcSelected', ccName);
            }
        };

        Odigeo.Session.set('page', page);
        Odigeo.Storage.remove('fromContinueButton');
        priceManagerCollection.fetchData();

        Odigeo.Router.eventController = $.extend(true, Odigeo.Router.eventController,
            Odigeo.Router.handlers.globalEventController,
            Odigeo.Router.handlers.userEventController,
            Odigeo.Router.handlers.repriceManagerEventController,
            Odigeo.Router.handlers.errorManagerEventController,
            {
                globalEvents: {},
                viewEvents: Odigeo._.extend(paymentGeneric.viewEvents(), paymentHandlerResponse.confirmationEvents(), {
                    'payment-error-manager:sendValidationErrors': 'sendValidationErrors',
                    'invoice-manager:clearValidationErrors': 'onInvoiceManagerClearValidationErrors',
                    'invoice-manager:showErrorsResume': 'onShowInvoiceManagerErrorsResume',
                    'payment-bin-detection-manager:creditCardTypeChanged': 'onCreditCardChanged',
                    'payment-bin-detection-manager:methodTypeChanged': 'onCcMethodTypeSelected',
                    'payment-bin-detection-manager:showPaymentMethodDisclaimer': 'onShowPaymentMethodDisclaimer',
                    'payment-manager:confirmationLoading': 'onConfirmationLoading',
                    'payment-manager:noPaymentMethodsAvailable': 'onNoPaymentMethodsAvailable',
                    'payment-manager:paymentMethodChanged': 'onPaymentMethodChanged',
                    'payment-manager:paymentOptionsUpdated': 'onCreditCardListReady',
                    'payment-manager:ready': 'onPaymentManagerReady',
                    'payment-manager:showErrors': 'onShowErrors',
                    'payment-manager:showErrorsResume': 'onShowPaymentErrorsResume',
                    'payment-manager:updateCardMethod': 'onUpdateCardMethod',
                    'payment-manager:expirationDateChange': 'onExpirationDateChange',
                    'payment-manager:creditCardTypeChanged': 'onCreditCardChanged',
                    'price-breakdown-payments:priceManagerReady': 'onPriceManagerReady',
                    'price-breakdown-payments:refreshData': 'onPriceManagerReady',
                    'price-breakdown-payments:updatePricesTripSummary': 'onUpdatePrices',
                    'price-breakdown-payments:toggleCcType': 'onToggleCcType',
                    'price-breakdown-payments:breakdownLoaded': 'onBreakdownLoaded',
                    'price-breakdown-payments:onContinueButtonClicked': 'onContinueButtonClicked',
                    'price-breakdown-payments:trackContinueButtonMouseover': 'onTrackContinueButtonMouseover',
                    'price-breakdown-payments:priceBreakdownToggled': 'onPriceBreakdownToggled',
                    'specialrequest:clearValidationErrors': 'onSpecialrequestClearValidationErrors',
                    'trip-summary-price-payment:changeBackPage': 'changeBackPage',
                    'trip-summary-price-payment:toggleDetails': 'onDpToggleAccommodationDetails',
                    'sidebar-summary-payment:toggleDetails': 'onDpToggleAccommodationDetails',
                    'global:repricingShown': 'onRepricing',
                    'shoppingcart-manager:enablePaymentButton': 'enablePaymentButton',
                    'price-breakdown-payments:updateSummaryPrices': 'onUpdateSummaryPrices',
                    'price-breakdown-payments:totalPriceUpdated': 'refreshOfferPricesTextSize',
                    'pay-with-guarantee:rendered': 'refreshOfferPricesTextSize',
                    'dialog:redirectToHome': 'onRedirectToHome',
                    'payment-button:checkPaymentFormIsValidAndAgreed': 'checkPaymentFormIsValidAndAgreed',
                }),
                eventHandlers: Odigeo._.extend(paymentGeneric.eventHandlers(), {
                    onPromotionalCodesUpdatePrices: Odigeo._.noop,

                    onUserInteractionNeeded: (data) => paymentHandlerResponse.onUserInteractionNeeded(data),
                    onBookingConfirmedLoaded: (data) => paymentHandlerResponse.onBookingConfirmedLoaded(data),
                    onBookingError: (data) => paymentHandlerResponse.onBookingError(data),
                    onBookingPaymentRetryLoaded: (data) => paymentHandlerResponse.onBookingPaymentRetryLoaded(data),
                    onBookingRepricingLoaded: (data) => paymentHandlerResponse.onBookingRepricingLoadedDesktop(data, $priceBreakDownContainer),

                    onRedirectToHome: function() {
                        trackingUtils.trackEventWithCategory('pb_dynpack_pay_page', 'nags', 'nag_error_booking_not_contract_status_new_search');
                        Odigeo.Utils.goToApplicationHome();
                    },

                    onDpToggleAccommodationDetails: function(settings) {
                        widgets.accommodationDetails().execute('process', settings);
                    },

                    refreshOfferPricesTextSize: function() {
                        asyncWidgets.getPriceManagerEnhanced().execute('refreshOfferPricesTextSize');
                    },
                    onPriceBreakdownToggled: function() {
                        this.refreshOfferPricesTextSize();
                    },
                    onUpdateSummaryPrices: function() {
                        var updatePrices = isSidebarSummary ? 'refreshPrice' : 'updatePrices';
                        asyncWidgets.getSidebar().execute(updatePrices);
                    },
                    onToggleCcType: function(show) {
                        asyncWidgets.getSidebar().execute('toggleCcType', show);
                    },
                    // This event accepts either an array of error objects or a single error object in the following
                    // format: {type: '', validationResult: ''}
                    sendValidationErrors: function(errors) {
                        widgets.getPaymentErrorManager().execute('updateErrorsCollection', errors);
                    },
                    onUpdateFlagPriceManager: function(flag) {
                        asyncWidgets.getPriceManagerEnhanced().execute('updateFlag', flag);
                    },
                    onConfirmationLoading: function() {
                        $logo.addClass('disabled');
                        Odigeo.Session.remove('before-page');
                    },
                    onCreditCardChanged: function(ccType, ccName, ccResolved, showCCDropdown) {
                        if (!!ccType && ccType !== '-1') {
                            widgets.getPaymentManager().execute('setCreditCardType', ccType, showCCDropdown);
                        }
                        var paymentManager = widgets.getPaymentManager();
                        if (paymentManager.model.get('chosenMethod') === 'CREDITCARD') {
                            _submitPriceManagerRequest('showCcSelected', ccName, ccResolved);
                        }

                        if (!isSidebarSummary) {
                            asyncWidgets.getSidebar().execute('setCcSelected', ccName);
                        }
                    },
                    onShowPaymentMethodDisclaimer: function(data) {
                        _submitPriceManagerRequest('showPaymentMethodDisclaimer', data.ccName, data.resolved);
                    },
                    onBreakdownLoaded: function() {
                        _submitBinDetectionRequest('getCcSelectedName');
                        widgets.getPaymentManager().execute('isStoredCardSelected');
                    },
                    onRepricing: function() {
                        Odigeo.requireWidget('payment-page-top-persuasive-message', 'persuasiveMessaging', function(persuasiveMessaging) {
                            persuasiveMessaging.execute('closeMessage');
                        });
                    },
                    enablePaymentButton: function() {
                        togglePaymentBtn({loading: false, disabled: false}, {loading: false, disabled: false});
                    },
                    onPaymentMethodChanged: function(method) {
                        if (method !== 'CREDITCARD') {
                            _submitPriceManagerRequest('showCcSelected', '');
                        } else {
                            _submitBinDetectionRequest('getCcSelectedName');
                        }
                    },
                    onCreditCardListReady: function(ccList) {
                        _submitBinDetectionRequest('setCCFees', ccList);
                    },
                    onCcMethodTypeSelected: function(ccName) {
                        var paymentManager = widgets.getPaymentManager();
                        if (paymentManager.model.get('chosenMethod') === 'CREDITCARD') {
                            _submitPriceManagerRequest('showCcSelected', ccName);
                        }
                    },
                    onPaymentManagerReady: function() {
                        // enhance payment creditcard expiration
                        var ccExpiration = Odigeo.UIElements.enhanceDateWithSelects($('#ccExpiration'), {yearLimit: 2050});
                        widgets.getPaymentManager().execute('enhancedElementList', {
                            'uielement': 'ccExpiration',
                            'element': ccExpiration,
                        });
                        Odigeo.UIElements.enhanceDateWithSelects($('#cnBirthDate'), {yearLimit: 1910});

                        asyncWidgets.getPriceManagerEnhanced().execute('reloadPrices');

                        Odigeo.Utils.sessionTimer.reset();

                        trackingUtils.trackPage('payment', {
                            legacy: Odigeo.Utils.getFunnelTrackingLegacy() + 'pago/',
                            funnel: true,
                        });

                        tagManagement.updateDatalayer();

                        $payment.removeClass('hidden');
                        Odigeo.UIElements.enhanceLoading($('.waiting_page')).hideLoading();

                        $payment.find('.paypal_info_hint').off().on(Odigeo.Events.tap, function(e) {
                            e.preventDefault();
                            window.open($(e.target).data('url'), '_blank', 'scrollbars=1,resizable=1,height=300,width=450');
                        });

                        Odigeo.Utils.patchFormsForiOS8($payment);

                        if (widgets.getPaymentManager().isPaymentMethodRetry || widgets.getPaymentManager().isRepricing) {
                            widgets.getPaymentManager().isRepricing = false;
                        }
                        // reset paymentMethodRetryFlag
                        widgets.getPaymentManager().isPaymentMethodRetry = false;

                        var error = widgets.getPaymentManager().error;
                        // In case we come from confirmation we check if there's an error and we show it
                        if (!Odigeo._.isUndefined(error)) {
                            widgets.getPaymentErrorManager()
                                .execute('updateErrorsCollection', error)
                                .execute('scrollToError');
                            widgets.getPaymentManager().error = null;
                        }

                        if (Odigeo.Utils.isRequestApp('dp') || Odigeo.Utils.isRequestApp('upsell')) {
                            Odigeo.trigger('reprice-manager:checkRepricing', '#repricing-notification-payment');
                        }
                    },

                    onPriceManagerReady: function() {
                        $('input[name=agree]').off('change').on('change', function() {
                            if ($('input[name=agree]').prop('checked')) {
                                $('.pricebreakdown_remember_tooltip').addClass('hidden');
                            }
                        });

                        Odigeo.trigger('reprice-manager:checkRepricing', '#repricing-notification-payment');
                        Odigeo.UIElements.hint.enhance(Odigeo.History.getPageNameFromFragment(), $('.flightsummary_layover_hint_payment'), {
                            events: {
                                hover: true,
                            },
                        });
                        widgets.getPaymentManager().execute('updateFees');
                    },

                    onUpdateCardMethod: function() {
                        // when users update any info the tooltip must be hidden
                        $('.payment_method_remember_tooltip').addClass('hidden');
                    },

                    onUpdatePrices: function(data) {
                        asyncWidgets.getSidebar().execute('updatePrices', data);
                    },

                    onShowPaymentErrorsResume: function(errorList) {
                        var errorTxt = '';
                        var $errorContainer = $payment.find('.paymentmanager_validation_errors');
                        if (!Odigeo._.isUndefined(errorList) && Odigeo._.keys(errorList).length > 0) {
                            if (!$ccNotDetected.hasClass('hidden') && $ccCardType.val() === '-1') {
                                errorList.cardType = 'empty';
                            }
                            Odigeo._.each(errorList, function(errorType, inputName) {
                                var txt;
                                var inputNameSelector = {
                                    'creditCardExpiration': 'cardExpirationMonth',
                                }[inputName] || inputName;
                                var $selector = $('input[name=' + inputNameSelector + '], select[name=' + inputNameSelector + ']');
                                if ($selector.length > 0) {
                                    txt = $selector.closest('.card_field')
                                        .find('.form-' + (errorType === 'invalid' ? 'error' : 'empty')).text().trim();
                                    if (txt !== '') {
                                        errorTxt = errorTxt + '<li>' + txt + '</li>';
                                    }
                                }
                            });

                            $errorContainer.html(errorTxt);
                            Odigeo.trigger('payment-manager:showErrors', 'newError');
                        }
                    },
                    onShowInvoiceManagerErrorsResume: function(errorList, opt) {
                        var $errorContainer = $payment.find('.invoicemanager_validation_errors');
                        var $errorContainerPayment = $payment.find('.paymentmanager_validation_errors');
                        var errorTxt = '';
                        var selector;
                        $errorContainerPayment.empty();
                        Odigeo._.each(errorList, function(iter) {
                            selector = '.form-' + (iter.errorType === 'invalid' ? 'invalid' : 'empty');
                            if (iter.name === 'invoice_name' || iter.name === 'invoice_id') {
                                selector = selector + ' span.' + opt;
                            }
                            var txt = $('input[name=' + iter.name + ']').parent().find(selector).text().trim();
                            errorTxt = errorTxt + '<li>' + txt + '</li>';
                        });
                        $errorContainer.html(errorTxt);

                        Odigeo.trigger('payment-manager:showErrors', 'newError');
                    },
                    onInvoiceManagerClearValidationErrors: function() {
                        $payment.find('.invoicemanager_validation_errors').html('');
                    },

                    onShowErrors: function() {
                        fieldUtils.scrollToFirstError($payment);
                    },
                    onSpecialrequestErrorsResume: function(errorList) {
                        var $errorContainer = $payment.find('.specialrequest_validation_errors');
                        var errorTxt = '';
                        var txt;
                        Odigeo._.each(errorList, function(iter) {
                            txt = $('[name="' + iter.name + '"]').data(iter.errorType);
                            errorTxt = errorTxt + '<li>' + txt + '</li>';
                        });
                        $errorContainer.html(errorTxt);
                    },

                    onSpecialrequestClearValidationErrors: function() {
                        $payment.find('.specialrequest_validation_errors').empty();
                    },

                    onNoPaymentMethodsAvailable: function() {
                        Odigeo.UIElements.showBrokenFlowError();
                    },

                    changeBackPage: function() {
                        window.history.back();
                    },

                    onExpirationDateChange: function($montSelect) {
                        if ($montSelect.attr('name') !== 'cardExpirationMonth') {
                            return;
                        }
                        var date = new Date();
                        var $yearSelect = $('select[name="cardExpirationYear"] option').eq(1);
                        var month = date.getMonth() + 1;
                        var val = parseInt($montSelect.val(), 10);

                        if (val < month) {
                            $yearSelect.attr('disabled', 'disabled');
                        } else {
                            $yearSelect.removeAttr('disabled');
                        }
                    },
                    validatePaymentPage: function() {
                        var $agreement = $('#i-agree-togglebutton');
                        const agreed = $agreement.is(':checked');
                        var invoiceManager = widgets.getInvoiceManager();
                        var paymentManager = widgets.getPaymentManager();
                        var isInvoiceValid = invoiceManager.get('isInvoiceValid', true);

                        if (isInvoiceValid) {
                            invoiceData = invoiceManager.get('getInvoiceData');
                            paymentManager.execute('setInvoiceRequestDTO', invoiceData.invoicemanager);
                        }

                        return widgets.binDetectionManager().get('isValid') && agreed &&
                            paymentManager.get('isValid') && isInvoiceValid;
                    },
                    showPaymentValidationErrors: function() {
                        var paymentManager = widgets.getPaymentManager();
                        var $agreement = $('#i-agree-togglebutton');
                        var agreed = $agreement.is(':checked');
                        if (!agreed) {
                            trackingUtils.trackEvent('confirm_purchase', 'conditions_unchecked_error');
                            Odigeo.trigger('payment-manager:showErrors', 'agree');
                        }

                        $agreement.closest('.payment_agree').attr('data-state', 'invalid');

                        Odigeo.UIElements.enhanceLoading($('.waiting_page')).hideLoading();
                        paymentManager.execute('commit', {simulate: true, showErrorsResume: true, displayErrors: true});
                        fieldUtils.scrollToFirstError($payment);
                    },
                    onContinueButtonClicked: function() {
                        trackingUtils.startMetric('LOAD_CONFIRM_DESKTOP');
                        trackingUtils.counterMetric(`FRONT${appName}PAYMENT_CLICK_COUNTER`);
                        if (this.validatePaymentPage()) {
                            widgetLoader.get('psd2PopupManager').execute('toggleWaiting', true);
                            trackingUtils.counterMetric(`FRONT${appName}PAYMENT_VALIDATION_OK_COUNTER`);
                            togglePaymentBtn({loading: true, disabled: true}, {loading: false, disabled: true});
                            var repricingClose = Odigeo.Session.get('repricingClose');
                            if (repricingClose) {
                                trackingUtils.trackEvent('repricing_popup', repricingClose);
                            }
                            this.onPaymentValidationSuccess();
                        } else {
                            trackingUtils.counterMetric(`FRONT${appName}PAYMENT_VALIDATION_KO_COUNTER`);
                            this.showPaymentValidationErrors();
                        }
                    },
                    onPaymentValidationSuccess: function() {
                        var paymentManager = widgets.getPaymentManager();

                        var $agreement = $('#i-agree-togglebutton');
                        $agreement.closest('.payment_agree').removeAttr('data-state');

                        this.enablePaymentButton();
                        paymentManager.execute('commit', {showErrorsResume: true, isAccommodationPostBooking: true});

                        widgets.getSpecialrequestManager().execute('analyticsEventTracking');
                    },
                    onFormValidationError({onErrorCallback = () => {}} = {}) {
                        trackingUtils.counterMetric(`FRONT${ appName }PAYMENT_VALIDATION_KO_COUNTER`);
                        this.showPaymentValidationErrors();
                        onErrorCallback();
                    },
                    checkPaymentFormIsValidAndAgreed(callback = () => {}) {
                        const isValid = this.validatePaymentPage();
                        const onFormValidationError = this.onFormValidationError.bind(this);

                        callback(new Promise((resolve, _) => {
                            if (!isValid) {
                                onFormValidationError();
                            }
                            resolve(isValid);
                        }));
                    },
                    onTrackContinueButtonMouseover: function() {
                        var paymentManager = widgets.getPaymentManager();
                        if (paymentManager.get('getPaymentMethod') === 'CREDITCARD' && !paymentManager.get('isValid')) {
                            var $tooltipPaymentMethod = $('.payment_method_remember_tooltip');
                            if ($tooltipPaymentMethod.hasClass('hidden')) {
                                trackingUtils.trackEvent('inline_bubbles', 'payment_form_bubble_appearances');
                                $tooltipPaymentMethod.removeClass('hidden');
                            }
                        }
                        if (!$('input[name=agree]').prop('checked')) {
                            var $tooltipPriceBreakdown = $('.pricebreakdown_remember_tooltip');
                            if ($tooltipPriceBreakdown.hasClass('hidden')) {
                                // Analytics: event tracking
                                trackingUtils.trackEvent('inline_bubbles', 'conditions_bubble_appearances');
                                $tooltipPriceBreakdown.removeClass('hidden');
                            }
                        }
                    },
                }),
            }
        );

        widgetLoader.get('paymentButton').execute('forceLoad');

        Odigeo._.each($persuasionMessagePopup, function(message) {
            Odigeo.UIElements.hint.enhance(Odigeo.History.getPageNameFromFragment(), message, {events: {tap: true}});
        });

        Odigeo.Router.eventController.execute();

        Odigeo.Utils.sessionTimer.reset();

        // Retrieve payment options
        widgets.getPaymentManager().execute('updatePaymentOptions');

        paymentGeneric.isLoggedIn();

        Odigeo.UIElements.enhanceLoading($('.waiting_page')).hideLoading();

        if (!Odigeo._.isNull(lastRoute) && lastRoute.from.name === 'confirmation') {
            if (!widgets.getPaymentManager().isPaymentMethodRetry && !widgets.getPaymentManager().isRepricing) {
                widgets.getPaymentManager().bookingAlreadyDone = true;
                Odigeo.UIElements.showBookingAlreadyDone('alert');
            }
        } else {
            Odigeo.Session.set('before-page', 'payment');
        }

        togglePaymentBtn = function(button, buttonWithGuarantee) {
            $payment.find('.payment_continue_button')
                .toggleClass('loading', button.loading).attr('disabled', button.disabled);
        };

        if (isSidebarSummary) {
            asyncWidgets.getSidebar().execute('updatePage', 'payment');
        }

        $window.scroll(function() {
            var scrollTop = $window.scrollTop();
            var sidebarMethod = isSidebarSummary ? 'stickPriceSection' : 'manageScroll';

            bodyHeight = $page.find('.body_content').height();

            footerTop = $footer.offset().top;

            paymentMainHeight = $payment.find('.left_payment_bar').height();

            asyncWidgets.getSidebar().execute(sidebarMethod, {
                scrollTop: scrollTop,
                bodyHeight: bodyHeight,
                footerTop: footerTop,
                paymentMainHeight: paymentMainHeight,
            });
        });
        trackingUtils.bindEvents($payment);

        var persuasiveName = Odigeo.Utils.parseJson(Odigeo.Session.get('bookingInfo')).buyer.name;
        if (!Odigeo._.isEmpty(persuasiveName) && Odigeo._.size($persuasiveTitleWithName) > 0) {
            $persuasiveTitleName.html(persuasiveName);
            $persuasiveTitleWithoutName.addClass('hidden');
            $persuasiveTitleWithName.removeClass('hidden');
        }

        changeTab.init('flights_pay_page');

        trackingUtils.stopMetric('LOAD_PAYMENTS_DESKTOP');

        widgets.getPaymentManager().execute('getPaymentOptions');
        sessionManagement.refreshSession(widgets.getPaymentManager().model.get('bookingId') + '', 'payment');

        handler3DS.initHandler(paymentHandlerResponse);
    };
}());
